/* @flow */
import { GET_SHOPS, SET_VIEW_SHOP, ADD_TO_FAVORITE, REMOVE_FAVORITE } from '../configs/constants'

export function getShops() {
  return { type: GET_SHOPS }
}

export function setViewShop(shops) {
  return { type: SET_VIEW_SHOP, shops }
}

export function addToFavorite(payload) {
  return { type: ADD_TO_FAVORITE, payload }
}

export function removeFavorite(payload) {
  return { type: REMOVE_FAVORITE, payload }
}


// WEBPACK FOOTER //
// ./src/actions/shop.js